import { Component, DestroyRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { LayoutService } from '../../../../../../../../@vex/services/layout.service';
import { UserRole } from '@eadsysteme/billingclient-v1';
import { MatButton } from '@angular/material/button';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatInput } from '@angular/material/input';
import { MatCheckbox } from '@angular/material/checkbox';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';

@Component({
	selector: 'ara-edit-user-role-dialog',
	imports: [
		ReactiveFormsModule,
		FormsModule,
		MatButton,
		MatDialogActions,
		MatDialogContent,
		MatDialogTitle,
		MatFormField,
		MatIcon,
		MatLabel,
		MatOption,
		MatSelect,
		TranslocoDirective,
		MatInput,
		MatError,
		MatCheckbox,
		CdkDragHandle,
		CdkDrag,
	],
	templateUrl: './edit-user-role-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './edit-user-role-dialog.component.scss',
})
export class EditUserRoleDialogComponent {
	protected layoutService = inject(LayoutService);
	dialogRef = inject<MatDialogRef<EditUserRoleDialogComponent>>(MatDialogRef);
	protected formBuilder = inject(FormBuilder);

	private destroyRef: DestroyRef = inject(DestroyRef);
	protected userRole: UserRole;
	userRoleFormGroup: FormGroup;

	constructor() {
		const userRole = inject<UserRole>(MAT_DIALOG_DATA);

		this.userRole = userRole;
		this.createForm();
	}

	private createForm() {
		this.userRoleFormGroup = this.formBuilder.group(
			{
				name: [{ value: this.userRole.name, disabled: false }, Validators.pattern(new RegExp(/^[\p{Letter})0-9\-_\/\(\)., ]{0,100}$/u))],
				userRoleType: [{ value: this.userRole.userRoleType, disabled: true }, Validators.required],
				vacancyPossible: [{ value: this.userRole.vacancyPossible, disabled: false }],
			},
			{
				validators: [],
			}
		);

		this.userRoleFormGroup.markAllAsTouched();
	}

	close(toSave: boolean) {
		if (!toSave) {
			this.dialogRef.close();
			return;
		}
		const userRole: UserRole = {
			name: this.userRoleFormGroup.get('name').value,
			userRoleType: this.userRoleFormGroup.get('userRoleType').value,
			vacancyPossible: this.userRoleFormGroup.get('vacancyPossible').value,
		};
		this.dialogRef.close(userRole);
	}
}
